import React, { useState, useEffect, FunctionComponent } from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import { NEWS_COLUMNS } from "../../Values/tables";

import { filterStatus, searchAPIItem } from "../../Values/utils";

import CustomTable from "../../Components/CustomTable/CustomTable";
import styles from "../Analytics/Analytics.module.css";
import { fetchNews, fetchNewsMongo } from "../../Services/organizations";
import NewsModal from "../../Components/Modals/NewsModal/NewsModal";
import DeleteSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteSelectedModal";
import { showSnackbarAction,setCurrentRoute } from "../../Redux/actions";
import { googleAnalytics } from "../../Services/users";
import { useLocation } from 'react-router-dom';

type props = {
  history: any;
  organizationId: any;
  user:any;
};

const NewsPanel: FunctionComponent<props> = ({ history, organizationId,user }) => {
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [newsModal, setNewsModal] = useState(false);
  const [news, setNews] = useState<any[] | undefined>(undefined);
  const [status, setStatus] = useState("ALL");
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [owner, setOwner] = useState(true);
  const [deletePopup, setDeletePopop] = useState(false);
  const dispatcher = useDispatch();
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [cRoute,setCRoute]=useState("") 
  
       const location = useLocation();
        
          useEffect(() => {
            dispatcher(setCurrentRoute(location.pathname))
            setCRoute(location.pathname)
          }, [location]);

  useEffect(() => {
    if (organizationId) {
      fetchNewsMongo(organizationId, (val) => setNews(val));
    }
  }, [organizationId]);

  const clearSelectedRowsData = () => {
    setSelectedRowsData([]);
    setSelectedRows([]);
  };

  useEffect(() => {
    if (news) {
      let data: any[] = [];
      news.forEach((item) => {
        data.push(item);
      });
      console.log("newdata", data);
      setFilterData(data);
    }
  }, [news]);
  // useEffect(() => {
  //   if (selectedRows.length > 0) {
  //     setOwner(true);
  //   } else if (selectedRows.length === 0) {
  //     setOwner(false);
  //   }
  // }, [selectedRows]);

  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Admin_News_Screen',user)
      }
    }
  },[user])


  return (
    <>
      <div
        className={styles.parent}
        style={{ display: "block", marginTop: "0px", backgroundColor: "white" }}
      >
        <div
          className={commonStyle.topBar}
          style={{ marginTop: "0px", backgroundColor: "white" }}
        >
          <Topbar
            history={history}
            title={"Add News Link"}
            path={"/addUsers"}
            onChange={(val) => setsearchQuery(val)}
            filterText="Status"
            setColumnModal={(data) => setColumnModal(data)}
            show={false}
            owner={owner}
            deleteSelected={() => {
              if (selectedRows.length > 0) {
                setDeletePopop(true);
              } else if (selectedRows.length === 0) {
                dispatcher(
                  showSnackbarAction(
                    "Please Select The Record To Delete",
                    "error"
                  )
                );
              }
            }}
            showStatusBox={true}
            setApiModal={(data) => setNewsModal(data)}
            setStatus={(status) => setStatus(status)}
            status={status}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
          <CustomTable
            tableColumns={NEWS_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="NEWS"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchQuery(val)}
          />
          {deletePopup && (
            <DeleteSelectedModal
              data={selectedRowsData}
              clearSelectedRowsData={clearSelectedRowsData}
              open={deletePopup}
              tableType={"NEWS"}
              setOwner={setOwner}
              newsData={news}
              close={() => {
                setDeletePopop(false);
              }}
            />
          )}
        </div>
      </div>

      {newsModal === true && (
        <NewsModal open={newsModal} close={() => setNewsModal(false)} />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    user: state.user.data,
  };
};
export default connect(mapStateToProps)(NewsPanel);